// extracted by mini-css-extract-plugin
module.exports = {"CommonTitle":"CommonTitle_CommonTitle__nTmfH"};